import { forwardRef, MouseEvent, useMemo } from 'react';
import { Box, IconButton, styled } from '@mui/material';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { HangUpIcon } from 'assets';
import { ControlTooltip } from 'components';
import { useRoomHost } from 'hooks';

import styles from './HangUpButton.module.scss';

type HangUpButtonProps = {
  disabled?: boolean;
  className?: string;
  iconClassName?: string;
  withTooltip?: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
};

const HangUpIconStyled = styled(HangUpIcon)(({ theme }) => ({
  color: '#fff',
}));

export const HangUpButton = forwardRef<HTMLButtonElement, HangUpButtonProps>(
  ({ disabled, className, iconClassName, withTooltip, onClick }: HangUpButtonProps, ref) => {
    const { t } = useTranslation('providerRoom');
    const { isHost } = useRoomHost();

    const tooltipMessage = useMemo(() => {
      let tooltipMessage = '';

      if (withTooltip) {
        tooltipMessage = isHost ? t('endCall') : t('leaveCall');
      }

      return tooltipMessage;
    }, [withTooltip, isHost, t]);

    return (
      <ControlTooltip title={tooltipMessage} isDisabled={disabled}>
        <Box component='span' display='block' className={classnames(styles.deviceButton, className)}>
          <IconButton
            disabled={disabled}
            className={classnames(styles.deviceButton, className)}
            sx={{
              backgroundColor: '#FF3D3D !important',
            }}
            onClick={onClick}
            edge='end'
            aria-label={t('aria.hangUp')}
            ref={ref}
          >
            <HangUpIconStyled className={classnames(styles.icon, iconClassName)} />
          </IconButton>
        </Box>
      </ControlTooltip>
    );
  },
);
